import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { GLOBAL } from './global';

@Injectable({
  providedIn: 'root'
})
export class TestingRecordService {
  public url: string;
  public token;

  constructor(private _http: HttpClient) {
    this.url = GLOBAL.url + '/inventory/';
    this.token = JSON.parse(localStorage.getItem('token'));
    if (this.token === 'undefined') {
      this.token = null;
    }
  }

  showAll(json): Observable<any> {
    let url: string;
    url = this.url + 'list';

    return this.petition(url + '?page=1', json);
  }

  private petition(url, json = null, type = null): Observable<any> {
    this.token = JSON.parse(localStorage.getItem('token'));
    let params = 'authorization=' + this.token;

    if (json != null) {
      json = encodeURIComponent(JSON.stringify(json));
      params = params + '&json=' + json;
    }

    if (type != null) {
      params = params + '&type=' + type;
    }

    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded',
      'X-Requested-With': 'XMLHttpRequest'
    });

    return this._http.post(url, params, { headers }).pipe(
      map(res => res as any)
    );
  }
}
